import { Wrench, Database, FileSearch, Sparkles } from "lucide-react";

type Props = {
  tools?: string[];
  isStreaming?: boolean;
};

export function ToolCallIndicator({ tools, isStreaming }: Props) {
  if (!tools || tools.length === 0) return null;

  const getToolIcon = (toolName: string) => {
    if (toolName.includes("portfolio") || toolName.includes("patente")) {
      return <Database className="w-3 h-3 text-blue-500" />;
    }
    if (toolName.includes("prazo") || toolName.includes("deadline")) {
      return <FileSearch className="w-3 h-3 text-amber-500" />;
    }
    if (toolName.includes("knowledge") || toolName.includes("buscar")) {
      return <Sparkles className="w-3 h-3 text-emerald-500" />;
    }
    return <Wrench className="w-3 h-3 text-slate-500" />;
  };

  const formatToolName = (name: string) => {
    return name
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="my-1.5 flex flex-wrap gap-1.5 items-center">
      {tools.map((tool, idx) => (
        <span
          key={`${tool}-${idx}`}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[10px] font-medium transition-all ${
            isStreaming
              ? "border-blue-200 bg-blue-50/80 text-blue-700 animate-pulse"
              : "border-slate-200 bg-slate-50 text-slate-600"
          }`}
        >
          {getToolIcon(tool)}
          <span>{formatToolName(tool)}</span>
        </span>
      ))}
    </div>
  );
}
